import { useClassName } from '@/styles/JwVideoArticle';
import { ComponentProps } from '@/types/component';

import { Component } from '@/types/component';
import { mergeProps } from '@/utils/merge';

export interface VideoArticleUnmuteLabelProps extends ComponentProps<'span'> {}

export const VideoArticleUnmuteLabelComponent: Component<VideoArticleUnmuteLabelProps> = ({ children, ...props }) => {
  const className = useClassName('unmute_label', props);

  return <span {...mergeProps({ className }, props)}>{children}</span>;
};
